import { render, staticRenderFns } from "./SolicitarLaudo.vue?vue&type=template&id=33b4bdd0&scoped=true&lang=pug"
import script from "./SolicitarLaudo.vue?vue&type=script&lang=js"
export * from "./SolicitarLaudo.vue?vue&type=script&lang=js"
import style0 from "./SolicitarLaudo.vue?vue&type=style&index=0&id=33b4bdd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b4bdd0",
  null
  
)

export default component.exports